<style>
.bg-primary {
  background-color: #1a3665 !important;
}
.bg-active {
  background-color: #3e5d92;
}
.bg-subactive {
  background-color: #486ba7;
}
</style>
<template>
  <CCard>
    <CCardBody>
      <CRow>
        <FilterPengajuanRefund/>
      </CRow>
      <CRow>
        
        <CCol lg="12" class="table-responsive">
          <CDataTable style="widht:100% !important" :items="items" :fields="fields" hover sorter>
            <template #no="{index}">
              <td class="py-2">{{indexed == 0 ? index +1: index+indexed + 1}}</td>
            </template>
            <template #nama_lengkap="{item}">
              <td class="py-2">{{ item.nama_lengkap ? item.nama_lengkap : '-' }}</td>
            </template>
            <template #no_anggota="{item}">
              <td class="py-2">{{ item.no_anggota ? item.no_anggota : '-' }}</td>
            </template>
            <template #nama_layanan="{item}">
              <td class="py-2" v-if="item.nama_layanan == null ||  item.nama_layanan == ''">{{ item.nama_pembayaran }}</td>
              <td class="py-2" v-else >{{ item.nama_layanan ? item.nama_layanan : '-' }}</td>
            </template>
            <template #updated_at="{item}">
              <td class="py-2">{{ item.updated_at ? item.updated_at : '-' }}</td>
            </template>
            <template #nominal="{item}">
              <td class="py-2" v-if="item.nominal != null">Rp{{  formatPrice(item.nominal)  }}</td>
              <td class="py-2" v-else>Rp{{  formatPrice(item.nominal_payment)  }}</td>
            </template>
            <template #status_approval_keuangan="{item}">
              <td class="py-2 text-danger font-weight-bold" v-if="item.status_approval_keuangan == '0'">Ditolak</td>
              <td class="py-2 text-success font-weight-bold" v-else-if="item.status_approval_keuangan == '1'">Disetujui</td>
              <td class="py-2 text-danger font-weight-bold" v-else-if="item.status_approval_keuangan == '2'">Dibatalkan</td>
              <td class="py-2 text-warning font-weight-bold" v-else>Menunggu</td>
            </template>
           <template #aksi="{item}">
              <td class="py-2 d-flex align-items-center">
                 <template v-if="role_status && role_status.status_read">                
                <CButton
                  color="info"
                  class="btn-sm"
                  @click="editStatus(item)"
                  square>
                <font-awesome-icon icon="edit" /> 
                </CButton>
                 </template>
              </td>
           </template>
          </CDataTable>
          <CPagination
            style="float:right"
            :active-page.sync="currentPagePengajuanRefund"
            :pages="pagination.totalPages"
            responsive
          />
        </CCol>
      </CRow>
      <CModal
        title="Modal title"
        :show.sync="myModal"
        :no-close-on-backdrop="true"
        :centered="true"
      >
          <CRow>
            <div class="modal-body row my-n3">
                <div class="col-5">
                    <p class="font-weight-bold">No. Invoice</p>
                    <p class="font-weight-bold">Nama Lengkap</p>
                    <p class="font-weight-bold">Email</p>
                    <p class="font-weight-bold">No. Telepon</p>
                    <p class="font-weight-bold">Nama Bank</p>
                    <p class="font-weight-bold">No Rekening</p>
                </div>
                <div class="col-7">
                  <p class="font-weight-bold">: {{ detailUser.no_anggota ? detailUser.no_anggota : '-'  }}</p>
                  <p>: {{detailUser.nama_lengkap ? detailUser.nama_lengkap : '-'}}</p>
                  <p>: {{detailUser.email ? detailUser.email : '-'}}</p>
                  <p>: {{detailUser.no_telepon ? detailUser.no_telepon : '-'}}</p>
                  <p>: {{detailUser.nama_bank ? detailUser.nama_bank : '-'}}</p>
                  <p>: {{detailUser.no_rekening ? detailUser.no_rekening : '-'}}</p>
                </div>
            </div>
          </CRow>
        <template #header>
        <h6 class="modal-title h4 font-weight-bold">{{ title }}</h6>
      </template>
        <template #footer class="mt-2">
          <CButton @click="myModal = false" color="danger">Tutup</CButton>
        </template>
      </CModal>
       <CModal
        title="Modal title"
        :show.sync="modalVerif"
        :no-close-on-backdrop="true"
        :centered="true"
      >
        <CForm>
          <CRow>
            <CCol sm="12">
              <div class="modal-body row my-n3">
                <div class="col-5">
                    <p class="font-weight-bold">Kode Pembayaran</p>
                    <p class="font-weight-bold">Nama Anggota</p>
                    <p class="font-weight-bold" v-if="tipe_layanan == 'pelatihan'">Nama Pelatihan</p>
                    <p class="font-weight-bold" v-else>Nama Sertifikasi</p>
                    <p class="font-weight-bold">No. Handphone</p>
                    <p class="font-weight-bold">No. Telepon</p>
                    <p class="font-weight-bold">Email</p>
                    <p class="font-weight-bold">Bank</p>
                    <p class="font-weight-bold">Nama Rekening</p>
                    <p class="font-weight-bold">No. Rekening</p>
                    <p class="font-weight-bold">Bukti Refund</p>
                    
                </div>
                <div class="col-7">
                    <p>: {{ formData.id_invoice ? formData.id_invoice : ' - ' }}</p>
                    <p>: {{ formData.nama_lengkap ? formData.nama_lengkap : ' - ' }}</p>
                    <p>: {{ formData.nama_layanan ? formData.nama_layanan : ' - ' }}</p>
                    <p>: {{ formData.no_handphone ? formData.no_handphone : ' - ' }}</p>
                    <p>: {{ formData.no_telephone ? formData.no_telephone : ' - ' }}</p>
                    <p>: {{ formData.email ? formData.email : ' - ' }}</p>
                    <p>: {{ formData.nama_bank ? formData.nama_bank : ' - ' }}</p>
                    <p>: {{ formData.nama_rekening ? formData.nama_rekening : ' - ' }}</p>
                    <p>: {{ formData.no_rekening ? formData.no_rekening : ' - ' }}</p>
                    <p>: <button
                        :class="formData.file_bukti_refund == null ? 'btn btn-sm btn-secondary' : 'btn btn-sm btn-success'" 
                        :disabled="formData.file_bukti_refund == null" 
                        @click="lihatFile(formData.file_bukti_refund)">
                        Lihat File
                        </button>
                    </p>
                </div>
                <div class="col-12">
                    <div class="form-group">
                        <label for="" class="font-weight-bold">Alasan</label>
                        <textarea  
                        class="form-control"
                            cols="30"
                            readonly
                            v-model="formData.keterangan" 
                            rows="5">
                        </textarea>
                    </div>
                    <div class="form-group">
                        <label for class="font-weight-bold">Status</label>
                        <div class="d-flex align-items-center">
                        <div class="custom-control custom-radio custom-control-inline">
                            <input
                                type="radio"
                                class="custom-control-input"
                                name="customRadio"
                                id="aktif_refund"
                                value="1"
                                v-model="formData.status_approval_keuangan"                                
                            />
                            <label class="custom-control-label" for="aktif_refund">Disetujui</label>
                        </div>
                        <div class="custom-control custom-radio custom-control-inline">
                            <input
                                type="radio"
                                class="custom-control-input"
                                name="customRadio"
                                id="tidak_aktif_refund" 
                                value="0"
                                v-model="formData.status_approval_keuangan"
                            />
                            <label class="custom-control-label" for="tidak_aktif_refund">Ditolak</label>
                        </div>
                        </div>
                        <div class="form-group" v-if="formData.status_approval_keuangan == '0'">
                          <label for="" class="font-weight-bold">Keterangan</label>
                          <textarea cols="30" rows="5" class="form-control"></textarea>
                        </div>
                    </div>
                </div>
            </div>
            </CCol>
          </CRow>
        </CForm>
        <template #header>
          <h6 class="modal-title h4 font-weight-bold">Konfirmasi Pengajuan Refund</h6>
        </template>
        <template #footer class="mt-5">
          <CButton @click="modalVerif = false" color="danger">Tutup</CButton>
          <CButton type="submit" @click="postPengajuanRefund" color="success">Simpan</CButton>
        </template>
      </CModal>
    </CCardBody>
  </CCard>
</template>
<script>
import PaymentService from '@/services/finance/payment.service'
import { Pagination } from "@/mixins/Pagination";
import { AlertUtils } from "@/mixins/AlertUtils";
import { exportUtils } from '@/mixins/exportUtils';
import paymentService from '@/services/finance/payment.service';
import FilterPengajuanRefund from '@/components/finance/pembayaran/FilterPengajuanRefund'
import Utils from "@/services/utils.service";
import BaseUrl from "@/services/base-url";

const fields = [
  {
    key: "no",
    label: "No",
    sorter: true,
    filter: true
  },
  {
    key: "id_invoice",
    label: "Kode Pembayaran",
    sorter: true,
    filter: true
  },
  {
    key: "no_anggota",
    label: "No Anggota",
    sorter: true,
    filter: true
  },
  {
    key: "nama_lengkap",
    label: "Nama Peserta",
    sorter: true,
    filter: true
  },
  {
    key: "nama_layanan",
    label: "Nama Layanan",
    sorter: true,
    filter: true
  },
  {
    key: "updated_at",
    label: "Tanggal Pengajuan",
    sorter: true,
    filter: true
  },
  {
    key: "nominal",
    label: "Nominal",
    sorter: true,
    filter: true
  },
  {
    key: "status_approval_keuangan",
    label: "Status Approval",
    sorter: true,
    filter: true
  },
  {
    key: "aksi",
    label: "Aksi",
    sorter: false,
    filter: false
  },
  
];

export default {
  name: "Payment",
  
  mixins: [Pagination, AlertUtils, exportUtils],
  components : {
    FilterPengajuanRefund
  },
  data() {
    return {
      currentPagePengajuanRefund : 0,
      tipe_layanan: "",
      formData : {
        idRefund : '',
        status : '',
        tipeLayanan : '',
        status_approval_keuangan : '',
        id_invoice : '',
        nama_lengkap : '',
        nama_layanan : '',
        no_handphone : '',
        no_telephone : '',
        email : '',
        nama_bank : '',
        nama_rekening : '',
        no_rekening : '',
        file_bukti_refund : '',
      },
      formFilterData : {},
      items: [],
      detailUser : {
        no_anggota : '',
        nama_lengkap : ''
      },
      itemsDetails : [],
      indexed : 0,
      currentPagePembayaranOutstanding: 0,
      fields,
      tipe: 'pengajuan_refund',
      no: 1,
      collapseDuration: 0,
      content: [],
      myModal: false,
      modalVerif: false,
      title: '',
      role_status: null
    };
  },
  mounted() {
    this.roleData();
  },
  watch: {
    currentPagePengajuanRefund(value) {
        this.getData(
          value, 
          this.pageSize, 
          this.formFilterData.layanan, 
          this.formFilterData.tipe, 
          this.formFilterData.search, 
          this.formFilterData.periode, 
          this.formFilterData.id
        )
    }
  },
  methods: {
    roleData()
    {
      var user = JSON.parse(localStorage.getItem('user'));
      var data = user.singleData.detail_user.roles.find(el => el.url === '/keuangan/pembayaran' );  
      this.role_status = data;
    },
    lihatFile(item){
      let user = JSON.parse(localStorage.getItem('user'));
      let token = user.accessToken
      let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
      width=0,height=0,left=-1000,top=-1000`;
      window.open(
        Utils.baseurlFoUsers() + "/lihat-file/"+item+"/lokasi/file_refund/bearer/" + token,
        item,
        params
      );
    },
    editStatus(value) {
      this.modalVerif = true;
      this.formData.idRefund = value.id_refund;
      this.formData.status = value.status;
      this.formData.status_approval_keuangan = value.status_approval_keuangan;
      this.formData.tipeLayanan = value.tipe_layanan;
      this.formData.id_invoice = value.id_invoice
      this.formData.nama_lengkap = value.nama_lengkap
      this.formData.nama_layanan = value.nama_pembayaran
      this.formData.no_handphone = value.no_handphone
      this.formData.no_telephone = value.no_telephone
      this.formData.email = value.email
      this.formData.nama_bank = value.nama_bank
      this.formData.nama_rekening = value.nama_rekening
      this.formData.no_rekening = value.no_rekening
      this.formData.file_bukti_refund = value.file_bukti_refund
      this.formData.keterangan = value.keterangan
      this.tipe_layanan = value.tipe_layanan
    },
    postPengajuanRefund() {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });
      this.formData.status = this.formData.status_approval_keuangan
      PaymentService.putPengajuanRefund(this.formData)
      .then(() => {
        loader.hide()
        this.alertSuccess()
        this.getData(
          0, 
          this.pageSize, 
          this.formFilterData.layanan, 
          this.formFilterData.tipe, 
          this.formFilterData.search, 
          this.formFilterData.periode, 
          this.formFilterData.id
        )
        this.modalVerif = false

      }).catch(() => {
        loader.hide();
        this.alertError()
      })
    },
    formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },

    lihatDetail(item) {
      this.detailUser.no_anggota = item.no_anggota;
      this.detailUser.nama_lengkap = item.nama_lengkap;
      this.detailUser.email = item.email;
      this.getDetailOutstandingIuran(item.id_user);
    },

    getDetailOutstandingIuran(idUser) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });

      paymentService.getDetailOutstanding(idUser)
      .then(response => {
        this.itemsDetails = response.data.data
        loader.hide();
      }).catch(error => {
        // comment console console.log(error);
        loader.hide();
      })
    },

    changePageSize(e) {
      var pageSize = "";
      if (e.target.value == "Semua Data") {
        pageSize = "500";
        this.pageSize = pageSize;
      } else {
        pageSize = e.target.value;
        this.pageSize = pageSize;
      }
        this.getData('0', this.pageSize, this.tipe, this.searchPembayaran, "default", 'default');
    },

    changeData(value) {
      this.periode = value.valuePeriode;
      this.formFilterData = value
      this.getData(
        "0", 
        this.pageSize, 
        value.layanan, 
        value.tipe, 
        value.search, 
        value.periode, 
        value.id
      )
    },

  
    detail(item, index) {
      this.myModal = true
      this.title = 'Detail Pengajuan Refund'
      this.lihatDetail(item);
    },

    getData(
      currentPage, 
      pageSize, 
      layanan, 
      tipe, 
      filter, 
      periode, 
      id
    ) {
      let loader = this.$loading.show({
        container: false ? null : this.$refs.formContainer,
        canCancel: true,
        onCancel: this.onCancel
      });

      var vm = this;

      PaymentService.getPengajuanRefund(
        currentPage, 
        pageSize, 
        layanan, 
        tipe, 
        filter, 
        periode, 
        id
      )
        .then(response => {
          loader.hide();
          vm.items = response.data.data.content;
          vm.pagination.totalPages = response.data.data.totalPages ;
          if(vm.currentPagePengajuanRefund == 0) {
            vm.currentPagePengajuanRefund = response.data.data.pageable.pageNumber + 1;
          }
        })
        .catch(error => {
          // comment console console.log(error);
        });
    }
  }
};
</script>